module.exports = __webpack_public_path__ + "img/Account-Suite-Grey.5b7df8ae.svg";